export default "__VITE_ASSET__e7783360__"